import { useContext, useState } from "react";
import styles from "../styles/ChatbotSettings.module.css";
import { ChatbotPreview } from "./ChatbotPreview";
import {
  IoRemove,
  IoCloseSharp,
  IoAddSharp,
  IoInformationCircle,
} from "react-icons/io5";
import { LanguageContext } from "./App";
import React from "react";
import { updateSettings } from "./UploadChatBot";
import ReactLoading from "react-loading";

import { Button } from "./ui/button.tsx";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu.tsx";
import { TfiSave } from "react-icons/tfi";

export default function Settings({ chatbot }) {
  const [firstMessage, setfirstMessage] = useState(chatbot.firstMessage);
  const [name, setName] = useState(chatbot.name);
  const [companyName, setCompanyName] = useState(chatbot.companyName);
  const [header, setheader] = useState(chatbot.header);
  const [subHeader, setsubHeader] = useState(chatbot.subHeader);
  const [whatsapplink, setwhatsapplink] = useState(chatbot.whatsapplink);
  const [telegramlink, settelegramlink] = useState(chatbot.telegramlink);
  const [telegrambotToken, settelegrambotToken] = useState(
    chatbot.telegramBotKey
  );
  const [telegramGrouplink, settelegramGrouplink] = useState(
    chatbot.telegram_chat
  );
  const [links, setLinks] = useState(chatbot.allowed_urls);
  const [messagePopupDelay, setmessagePopupDelay] = useState(
    chatbot.messagePopupDelay / 1000
  );
  const [languageChatBot, setlanguageChatBot] = useState(chatbot.language);
  const [mainColor, setmainColor] = useState(chatbot.mainColor);
  const [humanSpeech, sethumanSpeech] = useState(chatbot.humanSpeech);
  const [aiSpeech, setaiSpeech] = useState(chatbot.aiSpeech);
  const [supportSpeech, setSupportSpeech] = useState(chatbot.supportSpeech);
  const [backgroundColor, setbackgroundColor] = useState(
    chatbot.backgroundColor
  );
  const [userInputColor, setuserInputColor] = useState(chatbot.userInputColor);
  const [messageText, setmessageText] = useState(chatbot.messageText);
  const [closeButton, setcloseButton] = useState(chatbot.closeButton);
  const [modal, setModal] = useState(false);
  const [modalTelegramBotToken, setModalTelegramBotToken] = useState(false);

  const [enterEmailText, setenterEmailText] = useState(chatbot.enterEmailText);
  const [emailSubmitText, setemailSubmitText] = useState(
    chatbot.emailSubmitText
  );
  const [initiallyAskForEmail, setinitiallyAskForEmail] = useState(
    chatbot.initiallyAskForEmail
  );
  const [toAskForEmail, settoAskForEmail] = useState(chatbot.toAskForEmail);
  const [turnOnAI, setTurnOnAI] = useState(chatbot.turnonai);

  const [language, setLanguage] = useContext(LanguageContext);

  const [loading, setLoading] = useState(false);

  return (
    <div className={styles.main}>
      <div
        style={{
          borderRadius: 12,
          width: "50vw",
          right: 0,
          margin: 20,
          padding: 20,
          height: "100vh",
          fontFamily: "Jost",
          fontWeight: 600,
          scrollbarWidth: "none",
          overflow: "scroll",
        }}
      >
        {loading ? (
          <div
            style={{
              display: "flex",
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "transparent",
            }}
          >
            <ReactLoading type="spin" color="#000" height={75} width={75} />
          </div>
        ) : null}
        {modalTelegramBotToken ? (
          <div
            style={{
              position: "absolute",
              width: "80%",
              height: "90%",
              backgroundColor: "#000",
              borderRadius: 8,
              zIndex: 10000,
              marginTop: -15,
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
              padding: 20,
            }}
          >
            <button
              className={styles["backBtn"]}
              onClick={() => {
                setModalTelegramBotToken(false);
              }}
              style={{ alignSelf: "flex-start" }}
            >
              <IoCloseSharp size={20} color="#fff" height={5} width={5} />
            </button>
            <h3
              style={{
                textAlign: "center",
                whiteSpace: "pre-wrap",
                color: "#fff",
              }}
            >
              {language === "en"
                ? `How to create a Telegram bot and connect it to our chatbot
            Your customers will be able to ask their questions right in Telegram.

            1. Go to BotFather (https://t.me/BotFather)
            2. Select the New Bot option
            3. Choose a name for your bot (Can be any name, we suggest naming '{Your company name} AI bot')
            4. Choose a username for your bot
            5. Copy the token (it looks something like this: 2345673257:jkasfghdjkgdjskhgjdkshgjsh-dsfgsdfg)
            6. Paste the token in this field
            
            That's it!
            
            `
                : `Как создать Telegram-бота и подключить его к нашему чат-боту
            Ваши клиенты смогут задавать свои вопросы прямо в Telegram.
            
            1. Перейдите на страницу BotFather (https://t.me/BotFather)
            2. Выберите опцию Создать бота
            3. Выберите имя для вашего бота (может быть любое имя, мы предлагаем назвать '{Название вашей компании} AI бот')
            4. Выберите username для вашего бота
            5. Скопируйте токен (он выглядит примерно так: 2345673257:jkasfghdjkgdjskhgjdkshgjsh-dsfgsdfg)
            6. Вставьте токен в это поле

            Все!
            `}{" "}
              {language === "en"
                ? "If you have any questions:"
                : "Если у вас есть вопросы:"}{" "}
              <a
                href="https://t.me/holygoose"
                target="_blank"
                rel="noreferrer"
                style={{ color: " #16a34a" }}
              >
                Telegram
              </a>
              ,{" "}
              <a
                href="https://wa.me/+79826005377"
                target="_blank"
                rel="noreferrer"
                style={{ color: " #16a34a" }}
              >
                WhatsApp
              </a>{" "}
              {language === "en" ? `or` : `или`}{" "}
              <a
                href="https://twitter.com/artemy_medvedev"
                target="_blank"
                rel="noreferrer"
                style={{ color: " #16a34a" }}
              >
                Twitter (X)
              </a>
            </h3>
          </div>
        ) : null}
        {modal ? (
          <div
            style={{
              position: "absolute",
              width: "80%",
              height: "90%",
              backgroundColor: "#000",
              borderRadius: 8,
              zIndex: 10000,
              marginTop: -15,
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
              padding: 20,
            }}
          >
            <button
              className={styles["backBtn"]}
              onClick={() => {
                setModal(false);
              }}
              style={{ alignSelf: "flex-start" }}
            >
              <IoCloseSharp size={20} color="#fff" height={5} width={5} />
            </button>
            <h3
              style={{
                textAlign: "center",
                whiteSpace: "pre-wrap",
                color: "#fff",
              }}
            >
              {language === "en"
                ? `How to create a group in Telegram and find its ID.
            All messages from the online chat will be forwarded in this group. Staff will be able to intervene in the dialogue with the bot.

            1. Create a group in Telegram.
            2. Go to the group settings and enable the "Topics" mode.
            3. Search for @RawDataBot (https://t.me/raw_data_bot) in Telegram.
            4. Press "Start."
            5. Click on "Chats."
            6. Select the group you created.
            7. Copy the Chat ID.
            8. Add @CyberChatAIBot bot (https://t.me/CyberChatAIBot) to the group
            9. Promote @CyberChatAIBot to group admin
            
            That's it!
            
            `
                : `Как создать группу в Telegram и найти ее ID.
            В эту группы будут приходить все сообщения с чата. Операторы смогут вмешиваться в диалог с ботом.

            1. Создайте группу в Telegram
            2. Зайдите в настройки группы и включите режим "Темы"
            3. Найдите в поиске Telegram @RawDataBot (https://t.me/raw_data_bot)
            4. Нажмите старт
            5. Нажмите "Чаты" (Chats)
            6. Выберите созданную группу
            7. Скопируйте Chat id
            8. Добавьте @CyberChatAIBot бота (https://t.me/CyberChatAIBot) в группу
            9. Сделайте @CyberChatAIBot администратором группы
            
            Все!
            
            `}{" "}
              {language === "en"
                ? "If you have any questions:"
                : "Если у вас есть вопросы:"}{" "}
              <a
                href="https://t.me/holygoose"
                target="_blank"
                rel="noreferrer"
                style={{ color: " #16a34a" }}
              >
                Telegram
              </a>
              ,{" "}
              <a
                href="https://wa.me/+79826005377"
                target="_blank"
                rel="noreferrer"
                style={{ color: " #16a34a" }}
              >
                WhatsApp
              </a>{" "}
              {language === "en" ? `or` : `или`}{" "}
              <a
                href="https://twitter.com/artemy_medvedev"
                target="_blank"
                rel="noreferrer"
                style={{ color: " #16a34a" }}
              >
                Twitter (X)
              </a>
            </h3>
          </div>
        ) : null}
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <h4 className={styles.paramName} style={{ color: "#000" }}>
              {language === "en"
                ? "Your telegram group ID"
                : "ID вашего телеграм чата"}{" "}
            </h4>
            <button
              style={{
                marginTop: 0,
                marginLeft: 5,
                backgroundColor: "transparent",
                border: "none",
              }}
              onClick={() => {
                setModal(true);
              }}
            >
              <IoInformationCircle
                size={20}
                color="#000"
                height={5}
                width={5}
              />
            </button>
          </div>

          <input
            className={styles.paramInput}
            defaultValue={
              telegramGrouplink === "-1002077617509" ? "" : telegramGrouplink
            }
            placeholder={
              language === "en" ? "Enter a value..." : "Введите значение..."
            }
            onChange={(event) => {
              settelegramGrouplink(event.target.value);
            }}
            readOnly={false}
          ></input>
        </div>

        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <h4 className={styles.paramName} style={{ color: "#000" }}>
              {language === "en"
                ? "Telegram bot Token (If you want to have an AI Telegram Bot): "
                : "Токен бота в Telegram (Если вы так же хотите AI Telegram бота): "}
            </h4>
            <button
              style={{
                marginTop: 0,
                marginLeft: 5,
                backgroundColor: "transparent",
                border: "none",
              }}
              onClick={() => {
                setModalTelegramBotToken(true);
              }}
            >
              <IoInformationCircle
                size={20}
                color="#000"
                height={5}
                width={5}
              />
            </button>
          </div>

          <input
            className={styles.paramInput}
            defaultValue={telegrambotToken}
            placeholder={
              language === "en" ? "Enter a value..." : "Введите значение..."
            }
            onChange={(event) => {
              settelegrambotToken(event.target.value);
            }}
            readOnly={false}
          ></input>
        </div>

        <Param
          name={
            language === "en"
              ? "After what time to send the first message (seconds): "
              : "Через какой время отправить первое сообщение (в секундах): "
          }
          defaultValue={messagePopupDelay}
          setValue={setmessagePopupDelay}
          readonly={false}
        ></Param>

        <LanguageToggle
          defaultValue={languageChatBot}
          setValue={setlanguageChatBot}
          language={language}
        ></LanguageToggle>

        <Links setValue={setLinks} value={links}></Links>

        <label style={{ color: "#000" }}>
          <input
            type="checkbox"
            checked={initiallyAskForEmail}
            value={initiallyAskForEmail}
            onChange={() => {
              setinitiallyAskForEmail(!initiallyAskForEmail);
            }}
          />
          {language === "en"
            ? " Requite email to start chatting?"
            : ` Просить email, чтобы начать чат`}
        </label>
        <br></br>
        <label style={{ color: "#000" }}>
          <input
            type="checkbox"
            checked={toAskForEmail}
            onChange={() => {
              settoAskForEmail(!toAskForEmail);
            }}
          />
          {language === "en"
            ? " Ask for email after every successfull answer?"
            : ` Спрашивать email после каждого удачного ответа?`}
        </label>
        <div className="radio">
          <label style={{ color: "#000" }}>
            <input
              type="checkbox"
              checked={turnOnAI}
              onChange={() => {
                setTurnOnAI(!turnOnAI);
              }}
            />
            {language === "en"
              ? " Turn on AI (recommended, without this option only you will be able to answer customer)"
              : ` Включите искусственный интеллект (рекомендуется, без этой опции отвечать клиенту сможете только вы)`}
          </label>
        </div>
        <br></br>

        {toAskForEmail || initiallyAskForEmail ? (
          <>
            <Param
              name={
                language === "en"
                  ? "Chatbot answer when user submits an email "
                  : "Что писать, когда пользователь ввел email "
              }
              defaultValue={emailSubmitText}
              setValue={setemailSubmitText}
              readonly={false}
            ></Param>

            <Param
              name={
                language === "en"
                  ? "Ask for email text "
                  : "Текст при запрашивании email "
              }
              defaultValue={enterEmailText}
              setValue={setenterEmailText}
              readonly={false}
            ></Param>
          </>
        ) : null}

        <br></br>

        <button
          className={styles.submitBtn}
          style={{
            marginBottom: 50,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
          onClick={async () => {
            if (
              name !== "" &&
              companyName !== "" &&
              header !== "" &&
              subHeader !== "" &&
              links.length !== 0 &&
              links[0] !== ""
            ) {
              setLoading(true);
              await updateSettings(
                name,
                links,

                telegramGrouplink,
                messagePopupDelay * 1000,
                telegrambotToken,

                enterEmailText,
                emailSubmitText,
                initiallyAskForEmail,
                toAskForEmail,
                turnOnAI,
                languageChatBot
              );
              setLoading(false);
            } else {
              if (language === "en") {
                alert("Please, fill in all fields!");
              } else {
                alert("Пожалуйста, заполните все поля!");
              }
            }
          }}
        >
          <TfiSave style={{ marginRight: 5 }} size={18} />
          {language === "en" ? "Save" : "Сохранить"}
        </button>
      </div>
      <div className={styles.showcaseContainer}>
        <ChatbotPreview
          firstMessage={firstMessage}
          header={header}
          subHeader={subHeader}
          whatsapplink={whatsapplink}
          telegramlink={telegramlink}
          mainColor={mainColor}
          humanSpeech={humanSpeech}
          aiSpeech={aiSpeech}
          supportSpeech={supportSpeech}
          backgroundColor={backgroundColor}
          userInputColor={userInputColor}
          messageText={messageText}
          closeButton={closeButton}
          enterEmailText={enterEmailText}
        ></ChatbotPreview>
      </div>
    </div>
  );
}

function Param({ name, defaultValue, setValue, readonly }) {
  const [language, setLanguage] = useContext(LanguageContext);

  return (
    <div>
      <h4 className={styles.paramName} style={{ color: "#000" }}>
        {name}{" "}
      </h4>
      <input
        className={styles.paramInput}
        defaultValue={defaultValue}
        placeholder={
          language === "en" ? "Enter a value..." : "Введите значение..."
        }
        onChange={(event) => {
          setValue(event.target.value);
        }}
        readOnly={readonly}
      ></input>
    </div>
  );
}

function Links({ setValue, value }) {
  const handleAddButtonClick = () => {
    setValue([...value, ""]);
  };
  const handleRemoveButtonClick = () => {
    if (value.length > 1) {
      let tempArray = [...value];

      tempArray.pop();

      setValue(tempArray);
    }
  };

  const handleInputChange = (event, index) => {
    const newList = [...value];
    newList[index] = event.target.value;

    setValue(newList);
  };

  const [language, setLanguage] = useContext(LanguageContext);

  return (
    <div style={{ marginTop: "20px", marginBottom: "20px" }}>
      <h4 style={{ paddingLeft: "5px", color: "#000" }}>
        {language === "en"
          ? `Websites where you would like to integrate a chatbot: `
          : `Cайты, куда вы бы хотели интегрировать чат-бота: `}
      </h4>
      <div></div>
      <h5 style={{ paddingLeft: "5px", color: "#000" }}>
        {language === "en"
          ? `It is necessary to insert not the links themselves, but the hosting name, for example:`
          : `Нужно вставить не сами ссылки, а имя хостинга, например:`}
        {"\n"}
      </h5>
      <h5 style={{ paddingLeft: "5px", color: "#000" }}>
        <a style={{ color: "#D22B2B" }}>https://cyberchat.crd.co/</a>
        {" ->"} <a style={{ color: "#008000" }}>cyberchat.crd.co</a>
      </h5>
      <h5 style={{ paddingLeft: "5px", color: "#000" }}>
        <a style={{ color: "#D22B2B" }}>
          https://www.w3schools.com/js/js_window_location.asp
        </a>
        {" ->"} <a style={{ color: "#008000" }}>www.w3schools.com</a>
      </h5>
      <h5 style={{ paddingLeft: "5px", color: "#000" }}>
        {language === "en"
          ? `Only on these sites will your chatbot work! If you're not sure,
                you can insert all the options. This is done for safety, so that no one
                couldn't install your chatbot on their website. The chatbot will also work
                on any port of localhost (localhost:3000, localhost:8080, etc.).`
          : `Только на этих сайтах будет работать ваш чат-бот! Если вы не уверены,
                можете вставить все варианты. Это сделано для безопасности, чтобы никто
                не смог установить ваш чат-бот на свой сайт. Чат-бот так же будет работать
                на любом порте localhost (localhost:3000, localhost:8080 и т.д.).`}
      </h5>
      <ul style={{ paddingTop: "5px" }}>
        {value.map((item, index) => (
          <li key={index} style={{ marginBottom: 5 }}>
            <input
              type="text"
              value={item}
              placeholder={
                language === "en" ? "Enter a link..." : "Введите ссылку..."
              }
              onChange={(e) => handleInputChange(e, index)}
              className={styles.paramInput}
            />
          </li>
        ))}
      </ul>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <button
          className={styles.backBtn}
          onClick={handleAddButtonClick}
          style={{ marginBottom: 0 }}
        >
          <IoAddSharp size={20} color="#000" height={5} width={5} />
        </button>
        <button
          className={styles.backBtn}
          onClick={handleRemoveButtonClick}
          style={{ marginBottom: 0 }}
        >
          <IoRemove size={20} color="#000" height={5} width={5} />
        </button>
      </div>
    </div>
  );
}

function LanguageToggle({ defaultValue, setValue, language }) {
  return (
    <DropdownMenu>
      <div style={{ display: "flex", flexDirection: "row", marginTop: 10 }}>
        <h4
          className={styles.paramName}
          style={{ color: "#000", marginRight: 10 }}
        >
          {language === "en"
            ? "Chatbot's main language (it will be able to understand any language, but works best with this one): "
            : "Основной язык чат-бота (он сможет понимать любой язык, но лучше всего работает с этим): "}
        </h4>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" className="ghost">
            {/* <Sun className="h-[1.1rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" /> */}
            {/* <Moon className="absolute h-[1.1rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" /> */}
            <span style={{ fontSize: 20 }}>{defaultValue}</span>
            <span className="sr-only">Change language</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={() => setValue("en")}>
            English
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setValue("ru")}>
            Русский
          </DropdownMenuItem>
        </DropdownMenuContent>
      </div>
    </DropdownMenu>
  );
}
